import { Component, NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AboutUsComponent } from './page/about-us/about-us.component';
import { ContactComponent } from './page/contact/contact.component';
import { DefaultComponent } from './page/default/default.component';
import { LayoutComponent } from './page/layout/layout.component';
import { MediaComponent } from './page/media/media.component';
import { NewsComponent } from './page/news/news.component';
import { NowSellComponent } from './page/now-sell/now-sell.component';
import { PricingComponent } from './page/pricing/pricing.component';
import { ProductContactComponent } from './page/product-contact/product-contact.component';
import { ProductsComponent } from './page/products/products.component';
import { BeOurDelaerComponent } from './page/beourdealer/be-our-dealer.component';
import { MobileAboutComponent } from './page/mobile/mobile-about.component';
import { MobileTermsOfUseComponent } from './page/mobile/mobile-terms-of-use.component';
import { MobileProtectionOfPersonalDataComponent } from './page/mobile/mobile-protection-of-personal-data.component';
import { MobilePrivacyPolicyComponent } from './page/mobile/mobile-privacy-policy.component';
import { MobileContactComponent } from './page/mobile/mobile-contact.component';
import { MobileBeOurDealerComponent } from './page/mobile/mobile-be-our-dealer.component';
import { MobileLayoutComponent } from './page/mobile/mobile-layout.component';
import { MobileAccountDeletionComponent } from './page/mobile/mobile-account-deletion.component';
import { AppRedirectComponent } from './page/app-redirect/app-redirect.component';

export const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children:
      [
        {
          path: '',
          component: DefaultComponent
        },
        {
          path: 'default',
          component: DefaultComponent
        },
        {
          path: 'about-us',
          component: AboutUsComponent
        },
        {
          path: 'contact',
          component: ContactComponent
        },
        {
          path: 'media',
          component: MediaComponent
        },
        {
          path: 'news/:id',
          component: NewsComponent
        },
        {
          path: 'now-sell',
          component: NowSellComponent
        },
        {
          path: 'instant-cash-offer',
          component: NowSellComponent
        },
        {
          path: 'pricing',
          component: PricingComponent
        },
        {
          path: 'used_car_pricing',
          component: PricingComponent
        },
        {
          path: 'product-contact/:id',
          component: ProductContactComponent
        },
        {
          path: 'products',
          component: ProductsComponent
        },
        {
          path: 'be-our-dealer',
          component: BeOurDelaerComponent
        },
        {
          path: 'bayimiz-olun',
          component: BeOurDelaerComponent
        }
      ]
  },
  {
    path: 'mobile',
    component: MobileLayoutComponent,
    children: [{
      path: 'contact',
      component: MobileContactComponent
    }]
  },
  {
    path: 'mobile/about',
    component: MobileAboutComponent
  },
  {
    path: 'mobile/bayimiz-olun',
    component: MobileBeOurDealerComponent
  },
  {
    path: 'mobile/mobile-privacy-policy',
    component: MobilePrivacyPolicyComponent
  },
  {
    path: 'mobile/mobile-protection-of-personal-data',
    component: MobileProtectionOfPersonalDataComponent
  },
  {
    path: 'mobile/mobile-terms-of-use',
    component: MobileTermsOfUseComponent
  },
  {
    path: 'mobile/account-deletion',
    component: MobileAccountDeletionComponent
  },
  {
    path: 'app',
    component: AppRedirectComponent
  },
  {
    path: '**',
    redirectTo: ''
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
